import styled from 'styled-components/macro'

export const AppContainer = styled.div`
  overflow: hidden;
`
